import { publisherByID, publisherCreate, publisherDestroy, publisherList, publisherUpdate } from '@/services/ventures/publishers.service'

export default {
	namespaced: true,
	state: {
		publisherList: { meta: { pagination: { total: 0 } } },
		publisher: {},
		publisherStatus: 'pending',
		publisherSaveStatus: 'init',
		publisherDeleteStatus: 'init',
	},
	getters: {
		getPublisherList: s => s.publisherList,
		getPublisher: s => s.publisher,
		getPublisherStatus: s => s.publisherStatus,
		getPublisherSaveStatus: s => s.publisherSaveStatus,
		getPublisherDeleteStatus: s => s.publisherDeleteStatus,
	},
	mutations: {
		PUBLISHER_LIST(state, value) { state.publisherList = value },
		SET_PUBLISHER(state, value) { state.publisher = value },
		PUBLISHER_STATUS(state, value) { state.publisherStatus = value },
		PUBLISHER_SAVE_STATUS(state, value) { state.publisherSaveStatus = value },
		PUBLISHER_DELETE_STATUS(state, value) { state.publisherDeleteStatus = value },
	},
	actions: {
		async fetchPublisherList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('PUBLISHER_STATUS', 'pending')
			commit('PUBLISHER_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await publisherList(params)
				commit('PUBLISHER_STATUS', 'init')
				commit('PUBLISHER_LIST', data)
				return data
			} catch (error) {
				commit('PUBLISHER_STATUS', 'init')
				throw error
			}
		},
		async savePublisher({ commit }, params) {
			commit('PUBLISHER_SAVE_STATUS', 'pending')
			try {
				const { data } = await publisherCreate(params)
				commit('PUBLISHER_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('PUBLISHER_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updatePublisher({ commit }, params) {
			commit('PUBLISHER_SAVE_STATUS', 'pending')
			try {
				const { data } = await publisherUpdate(params)
				commit('PUBLISHER_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('PUBLISHER_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deletePublisherByID({ commit }, params) {
			commit('PUBLISHER_DELETE_STATUS', 'pending')
			try {
				const { data } = await publisherDestroy(params)
				commit('PUBLISHER_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('PUBLISHER_DELETE_STATUS', 'error')
				return error
			}
		},
	},
}
